import type { ZudokuConfig } from "zudoku";
import "./global.css";

const config = {
  site: {
    // title: "BI Helper API Documentation",
    logo: {
      src: {
        light: "/logo.png",
        dark: "/logo.png",
      },
      alt: "BI Helper",
      width: "120px",
      href: "/",
    },
  },
  metadata: {
    favicon:
      "https://cdn.prod.website-files.com/674d61c2403cc284ff4154be/675ab65e58c0623058b32095_favicon-32x32.png"
  },
  page: {
    logo: {
      src: {
        light: "/logo.png",
        dark: "/logo.png"
      },
      alt: "BI Helper"
    },
  },
  theme: {
    light: {
      background: "#ffffff",
      foreground: "#000000",
      primary: "#0057ff",
      primaryForeground: "#ffffff",
      radius: "8px"
    },
    dark: {
      background: "#0d1117",
      foreground: "#ffffff",
      primary: "#4184ff",
      primaryForeground: "#ffffff",
      radius: "8px"
    },
    fonts: {
      sans: {
        url: "https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap",
        fontFamily: "Inter, sans-serif"
      },
    },
  },

  /* ----------  NAVIGATION ---------- */
  navigation: [
    { type: "doc", file: "index", path: "/", label: "Get started" },
    {
      type: "link",
      to: "api",            // must match the path below (no slash needed)
      label: "API Reference",
      icon: "code"
    },
  ],

  /* ----------  API REFERENCE ---------- */
  apis: [
    {
      path: "api",          // replaces deprecated navigationId
      type: "file",
      input: "../config/routes.oas.json" // relative path to your OAS file
    },
  ],
} as unknown as ZudokuConfig;

export default config;
